'use strict';

/* eslint-disable no-inline-comments */

// Trainme sport list : https://trainmeco.notion.site/Disciplines-Database-Cat-gories-dc8222cfd4094dad8a16e965153fe771
const trainmeSports = {
  BOXING: [
    '55', // Boxe
    '1790', // Cardio Boxing
  ],
  DANCE: [
    '1193', // Danse
    '16', // Zumba
  ],
  GOLF: [
    '65', // Golf
  ],
  MARTIAL_ARTS: [
    '1787', // Tai Chi
    '1789', // Qi Gong
    '56', // Self-defense
  ],
  MEDITATION: [
    '1464', // Relaxation Meditation
    '1793', // Sommeil,
    '1798', // Sophrologie,
  ],
  PILATE_GYM: [
    '50', // Pilates
    '1801', // Pilates Fusion
    '1788', // Rose Pilate
  ],
  RUNNING: [
    '47', // Running
  ],
  STRETCHING: [
    '1463', // Stretching
    '1795', // Do-in automassage
    '1794', // Ergonomie
    '1800', // Massage,
    '1796', // Massage assis,
  ],
  TENNIS: [
    '45', // Tennis
  ],
  WALKING: [
    '1678', // Marche Nordique
  ],
  WEIGHT_TRAINING: [
    '54', // Musculation
    '1771', // Renforcement musculaire
    '51', // Circuit-training
    '52', // Prépa physique
    '53', // Remise en forme
  ],
  YOGA: [
    '48', // Yoga
    '1799', // Yoga du rire
    '1797', // Yoga du visage et des yeux
    '1802', // Yoga sur chaise
  ],
};

module.exports = trainmeSports;
